module.exports = __webpack_public_path__ + "img/qrcode.14675dbb.png";